import { MemoizedSelector } from '@ngrx/store';
import { OeeAppState } from '../oee.reducer';
import { IAppInitStatus } from './model';
import { distinctCreateSelector } from '../../shared/helper/ngrx-helper';

export const selectAppInitializingStatus: MemoizedSelector<OeeAppState, IAppInitStatus> = distinctCreateSelector(
  (state: OeeAppState) => ({
    status: state.app.initializingStatus.status,
    info: state.app.initializingStatus.info,
  }),
  (initializingStatus: IAppInitStatus): IAppInitStatus => ({
    status: initializingStatus.status,
    info: initializingStatus.info,
  }),
);
